/*
 * SecondLap — compteur de marques.
 * Le nombre exact ne peut pas être calculé côté accueil : Liquid n'y parcourt
 * que 250 produits. On interroge donc /collections/all?view=brand-count, un
 * gabarit qui ne renvoie que le nombre (quelques octets), calculé par Shopify
 * sur toute la collection via le filtre Marque.
 * En cas d'échec, la valeur écrite dans le thème reste affichée.
 */
(async () => {
  const targets = document.querySelectorAll('[data-sl-brand-count]');
  if (!targets.length) return;

  try {
    const response = await fetch(`${window.shopUrl || ''}/collections/all?view=brand-count`);
    if (!response.ok) throw new Error(response.status);

    const value = (await response.text()).trim();
    if (!/^[1-9]\d*$/.test(value)) return;

    targets.forEach((el) => {
      el.textContent = value;
    });
  } catch (error) {
    console.error('sl-brand-count', error);
  }
})();
